import { nomenclatureConstants } from "../../constants";

const defaultState = {
  items: [],
  itemsCharacteristics: [],
  item: {},
  loadingItems: false,
  loadingItemsCharacteristics: false,
  loadingItem: false,

  supplierOrders: [],
  loadingSupplierOrders: false,

  fetchedItemsCharacteristics: false,
  fetchedItem: false,
  fetchedItems: false,
  deleted: false,
  error: null,
};

function normalData(arr, hasCharacteristic = false, typePriceId = null) {
  if (!Array.isArray(arr)) return [];

  return arr.map((elem, index) => {
    let clientPrice = elem.salePrice ?? 0; // fallback
    if (elem?.typePrices && typePriceId != null) {
      const typePrice = elem.typePrices.find(
        (tp) => tp.namePrice?.id === typePriceId
      );
      clientPrice = typePrice?.valueCurrency ?? elem.salePrice ?? 0;
    }

    return {
      ...elem,
      index: index + 1,
      id: hasCharacteristic ? index + 1 : elem.id,

      categoryId: elem.category?.id,
      category:
        elem.category && typeof elem.category === "object"
          ? elem.category.nameCategory
          : elem.category && typeof elem.category === "string"
            ? elem.category
            : "Не указано",

      unitId: elem.unit ? elem.unit.id : null,
      unit:
        elem.unit && typeof elem.unit === "object"
          ? elem.unit.nameUnit
          : elem.unit && typeof elem.unit === "string"
            ? elem.unit
            : "Не указано",

      currencyId: elem.currency ? elem.currency.id : null,
      currency:
        elem.currency && typeof elem.currency === "object"
          ? elem.currency.nameCurrency
          : elem.currency && typeof elem.currency === "string"
            ? elem.currency
            : "Не указано",

      countryId: elem.country ? elem.country.id : null,
      country:
        elem.country && typeof elem.country === "object"
          ? elem.country.nameCountry
          : elem.country && typeof elem.country === "string"
            ? elem.country
            : "Не указано",

      taxId: elem.tax ? elem.tax.id : null,
      taxAmount: elem.tax ? elem.tax.value : 0,
      tax:
        elem.tax && typeof elem.tax === "object"
          ? elem.tax.value
          : elem.tax && typeof elem.tax === "string"
            ? elem.tax
            : "Не указано",

      // Добавляем вычисленный clientPrice
      clientPrice,
    };
  });
}

export const nomenclatureReducer = function (state = defaultState, action) {
  switch (action.type) {
    case nomenclatureConstants.GETALL_REQUEST_NOMENCLATURES:
      return {
        ...state,
        loadingItems: true,
        fetchedItems: false,
        error: null,
        deleted: false,
      };
    case nomenclatureConstants.GETALL_SUCCESS_NOMENCLATURES:
      return {
        ...state,
        items: normalData(action.response),
        loadingItems: false,
        fetchedItems: true,
      };
    case nomenclatureConstants.GETALL_FAILURE_NOMENCLATURES:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: false,
        error: action.error,
      };

    case nomenclatureConstants.GETALL_REQUEST_NOMENCLATURES_CHARACTERISTICS:
      return {
        ...state,
        loadingItemsCharacteristics: true,
        fetchedItemsCharacteristics: false,
        error: null,
        deleted: false,
      };
    case nomenclatureConstants.GETALL_SUCCESS_NOMENCLATURES_CHARACTERISTICS:
      return {
        ...state,
        itemsCharacteristics: normalData(action.response, true),
        loadingItemsCharacteristics: false,
        fetchedItemsCharacteristics: true,
      };
    case nomenclatureConstants.GETALL_FAILURE_NOMENCLATURES_CHARACTERISTICS:
      return {
        ...state,
        loadingItemsCharacteristics: false,
        fetchedItemsCharacteristics: false,
        error: action.error,
      };


    case nomenclatureConstants.GET_NOMENCLATURE_INVOICES_REQUEST:
      return {
        ...state,
        loadingSupplierOrders: true,
        supplierOrders: [],
        error: null,
      };

    case nomenclatureConstants.GET_NOMENCLATURE_INVOICES_SUCCESS:
      return {
        ...state,
        loadingSupplierOrders: false,
        supplierOrders: action.response,
      };

    case nomenclatureConstants.GET_NOMENCLATURE_INVOICES_FAILURE:
      return {
        ...state,
        loadingSupplierOrders: false,
        error: action.error,
      };

    case nomenclatureConstants.GETBYID_REQUEST_NOMENCLATURES:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null,
        deleted: false,
      };
    case nomenclatureConstants.GETBYID_SUCCESS_NOMENCLATURES:
      return {
        ...state,
        item: action.response,
        loadingItem: false,
        fetchedItem: true,
      };
    case nomenclatureConstants.GETBYID_FAILURE_NOMENCLATURES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case nomenclatureConstants.CREATE_REQUEST_NOMENCLATURES:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case nomenclatureConstants.CREATE_SUCCESS_NOMENCLATURES:
      return {
        ...state,
        item: action.response,
        loadingItem: false,
        fetchedItem: true,
        items: normalData([...state.items, action.response]),
      };
    case nomenclatureConstants.CREATE_FAILURE_NOMENCLATURES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case nomenclatureConstants.UPDATE_REQUEST_NOMENCLATURES:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case nomenclatureConstants.UPDATE_SUCCESS_NOMENCLATURES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        item: action.response,
        items: normalData(
          state.items.map((elem) => {
            if (elem.id === action.response.id) return action.response;
            return elem;
          })
        ),
      };
    case nomenclatureConstants.UPDATE_FAILURE_NOMENCLATURES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case nomenclatureConstants.ARCHIVE_REQUEST_NOMENCLATURES:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case nomenclatureConstants.ARCHIVE_SUCCESS_NOMENCLATURES:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        items: state.items.map((elem) => {
          if (elem.id === action.id) {
            const nextArchiveStatus = !elem.isArchive;
            return {
              ...elem,
              isArchive: nextArchiveStatus,
              characteristics: (elem.characteristics || []).map((char) => ({
                ...char,
                isArchive: nextArchiveStatus,
              })),
            };
          }
          return elem;
        }),
      };
    case nomenclatureConstants.ARCHIVE_FAILURE_NOMENCLATURES:
      return {
        ...state,
        loadingItem: false,
        error: action.error,
      };

    case nomenclatureConstants.ARCHIVE_REQUEST_CHARACTERISTIC:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case nomenclatureConstants.ARCHIVE_SUCCESS_CHARACTERISTIC:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        items: state.items.map((elem) => {
          const hasTargetChar = elem.characteristics?.some(
            (char) => char.id === action.id
          );
          if (hasTargetChar) {
            return {
              ...elem,
              characteristics: elem.characteristics.map((char) =>
                char.id === action.id
                  ? { ...char, isArchive: !char.isArchive }
                  : char
              ),
            };
          }
          return elem;
        }),
      };
    case nomenclatureConstants.ARCHIVE_FAILURE_CHARACTERISTIC:
      return {
        ...state,
        loadingItem: false,
        error: action.error,
      };

    case nomenclatureConstants.DELETE_REQUEST_NOMENCLATURES:
      return {
        ...state,
        item: {},
        loadingItems: true,
        loadingItem: false,
        fetchedItems: false,
        fetchedItem: false,
        error: null,
        deleted: false,
      };
    case nomenclatureConstants.DELETE_SUCCESS_NOMENCLATURES:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: true,
        items: normalData(state.items.filter((elem) => elem.id !== action.id)),
        deleted: true,
      };
    case nomenclatureConstants.DELETE_FAILURE_NOMENCLATURES:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: false,
        error: action.error,
        deleted: false,
      };

    case "RESET_ITEM_NOMENCLATURES":
      return {
        ...state,
        fetchedItem: false,
        loadingItem: false,
        deleted: false,
        item: {},
      };

    case "RESET_ITEMS_NOMENCLATURES":
      return {
        ...state,
        fetchedItems: false,
        loadingItems: false,
        deleted: false,
        items: [],
        error: null,
      };
    default:
      return state;
  }
};
